/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { Role } from '../../../enums/generated/role';

/** CreateUsersRequest — dark-roast DTO: UsersPostDto */
export const createUsersRequestSchema = z.object({ "candidateId": z.string().uuid().nullish(), "contactId": z.string().uuid().nullish(), "email": z.string().min(1), "firstName": z.string().min(1), "isActive": z.boolean().nullish(), "lastName": z.string().min(1), "password": z.string().nullish(), "roles": z.array(z.nativeEnum(Role)).min(1) });
export type CreateUsersRequest = z.infer<typeof createUsersRequestSchema>;
